function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makeStepperStyles = function makeStepperStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiStep: {
      styleOverrides: {
        root: {
          padding: primitives.spacings["0"],
          '&[class*="Mui-completed"]': {
            '& + [class*="MuiStepConnector-vertical"]': {
              marginLeft: "14px",
              '& [class*="MuiStepConnector-line"]': {
                borderColor: tokens.colors["fill-success"],
                borderWidth: primitives.spacings["1"]
              }
            },
            '& + [class*="MuiStep-root"]': {
              '& [class*="MuiStepConnector-horizontal"]': {
                '& [class*="MuiStepConnector-line"]': {
                  borderColor: tokens.colors["fill-success"],
                  borderWidth: primitives.spacings["1"],
                  top: primitives.spacings["1"]
                }
              }
            }
          }
        },
        alternativeLabel: {
          '& [class*="MuiStepButton-root"]': {
            alignItems: "flex-start",
            justifyContent: "flex-start"
          },
          '& [class*="MuiStepConnector-lineHorizontal"]': {
            position: "absolute",
            top: "5px",
            left: "-53%",
            right: "50%"
          }
        },
        vertical: {
          '& [class*="MuiStepContent-root"]': {
            marginLeft: "15.5px",
            borderLeft: "1.5px solid ".concat(tokens.colors["detail-1-transparent"]),
            paddingLeft: primitives.spacings["7"],
            paddingTop: primitives.spacings["5"]
          }
        }
      }
    },
    MuiStepButton: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, tokens.typography["body-copy-medium"]), {}, {
          "&:hover": {
            '& [class*="MuiStepLabel-iconContainer"]': {
              outline: "".concat(primitives.borderWidths.medium, " solid ").concat(primitives.colors.tint["iris-400"])
            },
            '& [class*="Mui-error"]': {
              '& [class*="MuiStepLabel-iconContainer"]': {
                outline: "".concat(primitives.borderWidths.medium, " solid ").concat(primitives.colors.tint["clay-300"])
              }
            }
          },
          "&:active": {
            '& [class*="MuiStepLabel-iconContainer"]': {
              outline: "".concat(primitives.borderWidths.large, " solid ").concat(primitives.colors.accent.plant)
            },
            '& [class*="Mui-error"]': {
              '& [class*="MuiStepLabel-iconContainer"]': {
                outline: "".concat(primitives.borderWidths.large, " solid ").concat(primitives.colors.tint["clay-300"])
              }
            }
          },
          "&:focus-visible": {
            '& [class*="MuiStepLabel-iconContainer"]': {
              outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["ink-focus"]),
              outlineOffset: "1px"
            }
          }
        })
      }
    },
    MuiStepConnector: {
      styleOverrides: {
        vertical: {
          marginLeft: "15.5px"
        },
        lineHorizontal: {
          borderTop: "1.5px solid ".concat(tokens.colors["detail-1-transparent"])
        },
        lineVertical: {
          borderLeft: "1.5px solid ".concat(tokens.colors["detail-1-transparent"])
        }
      }
    },
    MuiStepLabel: {
      styleOverrides: {
        root: {
          padding: primitives.spacings["0"],
          '&[class*="alternativeLabel"]': {
            flexDirection: "column",
            alignItems: "start",
            '& [class*="MuiStepLabel-label"]': {
              marginLeft: primitives.spacings["2"],
              marginTop: primitives.spacings["1"]
            },
            '& [class*="MuiStepLabel-labelContainer"]': {
              textAlign: "left",
              margin: primitives.spacings["0"]
            }
          }
        },
        iconContainer: {
          zIndex: 1,
          height: primitives.spacings["7"],
          width: primitives.spacings["7"],
          borderRadius: "50%",
          boxShadow: "".concat(tokens.colors["ink-on-background"], " 0 0 0 1.5px inset"),
          paddingRight: primitives.spacings["0"],
          marginRight: primitives.spacings["2"],
          '&[class*="Mui-active"]': {
            boxShadow: "".concat(tokens.colors["ink-on-background"], " 0 0 0 2px inset"),
            '& [class*="MuiSvgIcon"]': {
              "& text": {
                fontWeight: primitives.fontWeights.emphasized
              }
            }
          },
          '&[class*="Mui-completed"]': {
            boxShadow: "none",
            backgroundColor: tokens.colors["fill-success"]
          },
          '&[class*="Mui-completed"][class*="Mui-active"]': {
            boxShadow: " ".concat(tokens.colors["ink-on-background"], " 0 0 0 2px inset"),
            backgroundColor: primitives.colors.detail.transparent
          },
          '&[class*="Mui-error"]': {
            boxShadow: "none",
            backgroundColor: tokens.colors["fill-error"],
            '& [class*="MuiSvgIcon"]': {
              color: tokens.colors.background
            }
          },
          '&[class*="Mui-error"][class*="Mui-active"]': {
            boxShadow: "".concat(tokens.colors["ink-error"], " 0 0 0 2px inset"),
            backgroundColor: primitives.colors.detail.transparent,
            '& [class*="MuiSvgIcon"]': {
              color: tokens.colors["ink-error"]
            }
          },
          '&[class*="Mui-disabled"]': {
            boxShadow: "".concat(tokens.colors["detail-1-transparent"], " 0 0 0 1.5px inset"),
            backgroundColor: tokens.colors["detail-1-40-transparent"],
            '& [class*="MuiSvgIcon"]': {
              "& text": {
                fill: tokens.colors["ink-on-background-60"]
              }
            }
          },
          '& [class*="MuiSvgIcon"]': {
            height: primitives.spacings["7"],
            width: primitives.spacings["7"],
            "& text": {
              fontSize: primitives.fontSizes["2"],
              fill: tokens.colors["ink-on-background"]
            }
          }
        },
        horizontal: {
          '& [class*="MuiStepLabel-iconContainer"]': {
            padding: primitives.spacings["0"]
          }
        },
        label: {
          fontSize: primitives.fontSizes["3"],
          color: tokens.colors["ink-on-background"],
          '&[class*="Mui-active"]': {
            fontWeight: primitives.fontWeights.emphasized,
            color: tokens.colors["ink-on-background"]
          },
          '&[class*="Mui-completed"]': {
            color: tokens.colors["ink-on-background"]
          },
          '&[class*="Mui-disabled"]': {
            color: tokens.colors["ink-on-background-60"]
          }
        }
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          "& circle": {
            display: "none"
          }
        }
      }
    }
  };
};